import type { RentSituation } from '@einwert/valuation-api-client'
import { ContentChip } from 'ComponentLibrary'
import {
    getAssetNumberRatingChipProps,
    getAssetRatingChipProps,
} from 'ClientPortal/src/pages/Assets/AssetDetails/Valuation/ValuationMarketData/Comparables/constants'

import { useTranslation } from 'react-i18next'

type RatingChipProps = {
    rating?: number | RentSituation
}

export const RatingChip = ({ rating }: RatingChipProps) => {
    const { t: tMarketData } = useTranslation('terminology', { keyPrefix: 'marketData' })

    if (rating === undefined) {
        return <ContentChip size="small" label={tMarketData('ratings.noRating')} color="grey" />
    }

    return (
        <ContentChip
            size="small"
            {...(typeof rating === 'number'
                ? getAssetNumberRatingChipProps(rating, tMarketData)
                : getAssetRatingChipProps(rating, tMarketData))}
        />
    )
}
